import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
import { classNames } from "../../../utils";
export const BlurLogo = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = classNames(fillVariants({
      fill: "current"
    }), className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M12,0 C18.62736,0 24,5.37258 24,12 C24,18.62736 18.62736,24 12,24 C5.37258,24 0,18.62736 0,12 C0,5.37258 5.37258,0 12,0 Z M6.906012,12.432 L5.500008,12.432 L5.500008,17.808 L7.004016,18.99996 L10.482012,18.99996 L11.968008,17.80596 L11.968008,12.432 L10.562016,12.432 L10.562016,17.18604 L9.968016,17.66304 L7.513008,17.66304 L6.906012,17.18196 L6.906012,12.432 Z M18.18804,12.42996 L12.97596,12.42996 L12.97596,18.92796 L14.382,18.92796 L14.382,16.53996 L17.82396,16.53996 L18.09396,16.76496 L18.09396,18.927 L19.5,18.927 L19.5,16.24704 L19.06296,15.849 L19.5,15.399 L19.5,13.65696 L18.18804,12.42996 Z M17.61,13.76604 L18.09396,14.21796 L18.09396,14.931 L17.79996,15.20604 L14.382,15.20604 L14.382,13.76604 L17.61,13.76604 Z M10.710012,5.000004 L5.500008,5.000004 L5.500008,11.538012 L10.706016,11.572008 L12.02496,10.347012 L12.02496,8.728008 L11.650008,8.323008 L12.02496,7.878012 L12.02496,6.226008 L10.710012,5.000004 Z M14.37996,5.002008 L12.975,5.002008 L12.975,10.382004 L14.49696,11.571012 L19.26504,11.571012 L19.26504,10.234008 L15,10.234008 L14.37996,9.750012 L14.37996,5.002008 Z M10.349016,9.021012 L10.619016,9.245004 L10.619016,9.785004 L10.137012,10.23 L6.905016,10.211004 L6.905016,9.021012 L10.349016,9.021012 Z M10.134012,6.337008 L10.619016,6.788004 L10.619016,7.409004 L10.324008,7.684008 L6.906012,7.684008 L6.906012,6.337008 L10.134012,6.337008 Z" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== size || $[9] !== t2) {
    t4 = <svg aria-label="Blur" className={t2} fill="currentColor" height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = rest;
    $[8] = size;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};